import { createSelector } from '@reduxjs/toolkit';
import { ClusterId } from '../slices/clusters';
import { ColorItem } from '../slices/colors';
import { selectTagsByClusterId } from '../slices/tags';
import { sortAlphaBeta } from '../utils';
import { getColorWithHash } from '../utils/colors';

export const selectSortedTags = createSelector([selectTagsByClusterId], (tagsByClusterId) =>
  Object.values(tagsByClusterId)
    .flat()
    .sort((a, b) => sortAlphaBeta(a.label, b.label)),
);

export const selectSortedClusterTags = createSelector(
  [selectTagsByClusterId, (_state: unknown, clusterId: ClusterId | null) => clusterId],
  (tagsByClusterId, clusterId) =>
    (clusterId ? (tagsByClusterId[clusterId] ?? []) : []).toSorted((a, b) => sortAlphaBeta(a.label, b.label)),
);

export const selectTagColorItems = createSelector([selectSortedTags], (crops) => {
  return crops
    .filter((crop) => !!crop.color)
    .map((crop): ColorItem => ({
      id: String(crop.id),
      name: crop.label,
      color: getColorWithHash(crop.color),
    }));
});
